module.exports = __webpack_public_path__ + "img/name-2.3a7cf632.png";